import { MDXLayout } from "@/shared/components/MDX/MDXLayout";
import Content from "../../help/production-orders-create.mdx";

export function ProductionOrdersCreateHelpPage() {
  return (
    <MDXLayout>
      <Content />
    </MDXLayout>
  );
}
